import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    MyDate, 
    onlyUnique, 
    simpleStatusColorCodExcelHex,
    defaultEmptyDateTime, 
    weeknum, 
    weekDays
} from "src/components/common/functions";
export default function Export({
    filteredData, 
    week
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filteredData.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const mainData = filteredData.map(raw => raw.projectHashKey).filter(onlyUnique).map(f => filteredData.filter(raw => weeknum(raw.startTime) === week).filter(ff => ff.projectHashKey === f));
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const headers = ["", ...weekDays, "Total"]; 
        for(let totalI = 0; totalI < mainData.length; totalI++){
            const testData = mainData[totalI];
            let maxlength = 1;
            const worksheet = workbook.addWorksheet(null, {views: [{showGridLines: false}]});
            worksheet.state = "visible";
            worksheet.properties.defaultColWidth = 22.57;
            for(let z = 1; z < 10; z++){
                worksheet.mergeCells(1,2 * z - 1, 1,2 * z);
                worksheet.getCell(1,2 * z - 1).value = headers[z - 1];
                worksheet.getCell(1,2 * z - 1).alignment = { vertical: "middle", horizontal: "center" };
                worksheet.getCell(1,2 * z - 1).border = {
                    top: {style:"thin"},
                    left: {style:"thin"},
                    bottom: {style:"thin"},
                    right: {style:"thin"}
                }
            }
            for(let num = 0; num < 7; num++){
                const filterData = testData.filter(vx => (new Date(vx.startTime.substring(0, 10).replace(/-/g, "/"))).getDay() === (num===6?0:(num + 1)))
                .sort((a, b) => new Date(a.travelStartTime.replace(/-/g, "/")) > new Date((b.travelStartTime.replace(/-/g, "/"))) ? 1 : -1);
                const colData = [headers[num + 1]];
                maxlength = Math.max(maxlength, filterData.length);
                //`${filterData[i].projectNumber} - ${filterData[i].organizationName} - ${filterData[i].clientProjectNumber}`
                const cell = worksheet.getCell(1, 1);
                cell.value = `${testData[0].projectNumber} - ${testData[0].organizationName} - ${testData[0].clientProjectNumber}`;
                const maxwidth = cell.value.toString().length * (cell.font?cell.font.size / 11:1) - 18;
                worksheet.getColumn(1).width = maxwidth < 18 ? 18 : maxwidth;
                for(let i = 0; i < filterData.length; i++){
                    const cell =  worksheet.getCell(2 + i * 7, 2 * num + 3);
                    cell.value = filterData[i].userName;
                    worksheet.mergeCells(2 + i * 7, 2 * num + 3, 8 + i * 7, 2 * num + 3);
                    cell.alignment = { vertical: "middle", horizontal: "center",  wrapText: true };
                    cell.border = {
                        top: {style:"thin"},
                        left: {style:"thin"},
                        bottom: {style:"thin"},
                        right: {style:"thin"}
                    }
                    cell.font = {            
                        color: { argb: simpleStatusColorCodExcelHex[filterData[i].workLogStatus] }
                    };
                    colData.push(
                        filterData[i].preDriver,
                        filterData[i].travelStartTime === defaultEmptyDateTime.replace(/-/,"/")?"":filterData[i].travelStartTime, 
                        filterData[i].workStartTime === defaultEmptyDateTime.replace(/-/,"/")?"":filterData[i].workStartTime, 
                        filterData[i].hadLunch, 
                        filterData[i].workEndTime === defaultEmptyDateTime.replace(/-/,"/")?"":filterData[i].workEndTime, 
                        filterData[i].travelEndTime === defaultEmptyDateTime.replace(/-/,"/")?"":filterData[i].travelEndTime, 
                        filterData[i].postDriver
                    );
                }
                worksheet.getColumn(2 * num + 4).values = colData;
            }
            const headerColData = [`${testData[0].projectNumber }- ${testData[0].organizationName} - ${testData[0].clientProjectNumber}`];
            for(let ii = 0; ii < maxlength; ii++){
                worksheet.mergeCells(ii * 7 + 2, 1, ii * 7 + 8, 1); 
                worksheet.getCell(ii * 7 + 2, 1).value = `Person ${ii + 1}`;
                worksheet.getCell(ii * 7 + 2, 1).alignment = { vertical: "middle", horizontal: "center",  wrapText: true };
                worksheet.getCell(ii * 7 + 2, 1).border = {
                    top: {style:"thin"},
                    left: {style:"thin"},
                    bottom: {style:"thin"},
                    right: {style:"thin"}
                }
                worksheet.getCell(ii * 7 + 2, 2).value = "";
                headerColData.push(
                    "pre driver", 
                    "travel start", 
                    "work start", 
                    "lunch", 
                    "work end", 
                    "travel end", 
                    "post driver"
                    
                );
            }
            worksheet.getColumn(2).values = headerColData;
        }
        //-----------------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx}), 
            `Project Calendar export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    };
    return (
    <span className = "pointer" onClick = {exportFunc}>
        Export
    </span>
    )
}